import React from 'react';
import PropTypes from 'prop-types';
import { InjectCSS } from "../../../InjectCSS";
import { makeGridQueries } from "./helpers";
import { gridOptionsShape } from "./shapes";
export var GridPresets = {
  small: {
    minSize: 140,
    maxSize: 310,
    gutter: 16,
    edgeIndent: 20,
    minVisible: 0.1,
    maxVisible: 0.7
  },
  medium: {
    minSize: 350,
    maxSize: 420,
    gutter: 16,
    edgeIndent: 20,
    minVisible: 0.04,
    maxVisible: 0.95
  }
};
/**
 * Будет перемещено в ui-kit после завершения отладочных работ
 */
export var GridMediaQueryBuilder = function GridMediaQueryBuilder(_ref) {
  var children = _ref.children,
    options = _ref.options,
    count = _ref.count,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'custom' : _ref$name;
  return /*#__PURE__*/React.createElement(InjectCSS, {
    name: name,
    renderCSS: function renderCSS(id) {
      return makeGridQueries(id, count, options).join('\n');
    },
    "data-t-id": "components-GridMediaQueryBuilder"
  }, function (id) {
    return children(id);
  });
};
GridMediaQueryBuilder.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  children: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  options: PropTypes.shape(gridOptionsShape).isRequired
} : {};